import axiosInstance from "../../helpers/auth.helper/auth.helper"
const appointmentsServices = {
    getAllAppointmentsService: () => axiosInstance.get("/admin/appointment"),
    deleteUserService: (data) => axiosInstance.delete(`/admin/user/${data}`),
}


export default appointmentsServices